import { BASE_URLS, ENVIRONMENT_MODE } from "../../../config/constants";
import { AxiosResponse } from "axios";
import axios from "../../../config/axiosInterceptor";
import { RcFile } from "antd/es/upload";
import {
  ChangeCompanyStatusType,
  CreateCompanyType,
  UpdateCompanyClientManagerType,
  UpdateCompanyType,
} from "./types";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const uploadCompanyImage = async ({
  owner_id,
  image,
  image_type,
}: {
  owner_id: string;
  image: RcFile | File;
  image_type: string;
}): Promise<AxiosResponse<void>> => {
  const formData = new FormData();
  formData.append("owner_id", owner_id);
  formData.append("image", image);
  formData.append("image_type", image_type);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios.post(`${baseURL}uploadUserImage`, formData, config);
};

export const createCompany = (
  payload: CreateCompanyType
): Promise<AxiosResponse<CreateCompanyType>> => {
  return axios.post(`${baseURL}createCompany`, payload);
};

export const updateCompanyById = (
  id: string,
  payload: UpdateCompanyType
): Promise<AxiosResponse<UpdateCompanyType>> => {
  return axios.patch(`${baseURL}updateCompany/${id}`, payload);
};

export const updateCompanyClientManager = (
  id: string,
  payload: UpdateCompanyClientManagerType
): Promise<AxiosResponse<UpdateCompanyClientManagerType>> => {
  return axios.patch(`${baseURL}updateCompanyClientManager/${id}`, payload);
};

export const changeCompanyStatus = (
  id: string,
  payload: ChangeCompanyStatusType
): Promise<AxiosResponse<ChangeCompanyStatusType>> => {
  return axios.patch(`${baseURL}changeCompanyStatus/${id}`, payload);
};

export const switchUserCompanyId = (
  id: string
): Promise<AxiosResponse<ChangeCompanyStatusType>> => {
  return axios.patch(`${baseURL}switchUserCompanyId/${id}`);
};

export const deleteCompany = (
  companyIds: string[] | React.Key[]
): Promise<AxiosResponse<string>> => {
  return axios.delete(`${baseURL}deleteCompany`, { data: companyIds });
};
